import FilterWrapper from './filter-wrapper';
export default FilterWrapper;
